
import { ReactNode, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Spin, Result, Button } from "antd";
import { requestHotelProfile } from "@/AppRedux/actions/hotelProfile/"
import { useAppDispatch } from "@/AppRedux/store/hooks";
import HotelProfileStateHook from "@/hooks/useHotelProfileState";
import { useIntl } from "react-intl";

interface BookingPropertyGuardProps {
  children: ReactNode;
}

export default function BookingPropertyGuard({ children }: BookingPropertyGuardProps) {
  const dispatch = useAppDispatch();
  const { propcode } = useParams<{ propcode: string }>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const intl = useIntl();
  const { process } = HotelProfileStateHook()

  const firstLoadRef = useRef(true)

  useEffect(() => {
    const run = () => {
      setError(null)
      setLoading(true)
      if (!propcode) {
        setError("MISSING_PROPCODE");
        return;
      }
      dispatch(requestHotelProfile(propcode));
    }

    if(firstLoadRef.current){
      firstLoadRef.current = false
      run()
    }

  }, [propcode, dispatch])

  useEffect(() => {

    if (process.status === false && process.action === "HOTEL_REQUEST") {
      setError("NOT_FOUND")
    } else {
      setError(null)
    }

    setTimeout(() => {
      setLoading(false)
      
    }, 1000);

  }, [process])

  if (loading) {
    return (
      <div
        style={{
          minHeight: "40vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spin size="large" />
        <div style={{ marginLeft: 16, fontSize: 18, display: "block" }}>
          {intl.formatMessage({
            id: 'hotel.Fetchloading',
            defaultMessage: 'Fetching hotel information...',
          })}
        </div>
      </div>
    );
  }

  if (!propcode || error === "MISSING_PROPCODE") {
    return (
      <Result
        status="info"
        title={intl.formatMessage({ id: "booking.guard.missingPropcode.title" })}
        subTitle={intl.formatMessage({ id: "booking.guard.missingPropcode.subtitle" })}
        extra={
          <Button type="primary" href="/booking">
            {intl.formatMessage({
              id: 'label.backToHome',
              defaultMessage: 'Back to Home',
            })}
          </Button>
        }
      />
    );
  }

  if (error === "NOT_FOUND") {
    return (
      <Result
        status="404"
        title={intl.formatMessage({ id: "booking.guard.notFound.title" })}
        subTitle={intl.formatMessage({ id: "booking.guard.notFound.subtitle" })}
        extra={
          <Button type="primary" href="/booking">
            {intl.formatMessage({
              id: 'label.backToHome',
              defaultMessage: 'Back to Home',
            })}
          </Button>
        }
      />
    );
  }

  return <>{children}</>;
}
